import { apiClient, EMPTY_ARRAY, FilteredCreditApplication } from '@applyonline/shared'
import { QueryFunctionContext, useQuery } from '@tanstack/react-query'

export interface TermPlanOptionsRequestDto {
  amountRequested: number
  deliveryOn: string
  firstPaymentOn: string
  appliedPaymentPlanId: string | null
  selectedPaymentPlanId: string | null
}

export interface TermPlanOptionsResponseDto {
  term: number
  paymentPlanId: string
  promoRate: number
  promoDurationMonths: number | null
  amountWithoutInsurance: number
  amountWithInsurance: number
  insuranceDelta: number
  isValidWithInsurance: boolean
}

const TERM_PLAN_OPTIONS = 'termPlanOptions'

const keysFactory = {
  termPlanOptions: (creditApplicationId: string, versionTag: string, request: TermPlanOptionsRequestDto | null) =>
    [{ scope: TERM_PLAN_OPTIONS }, creditApplicationId, versionTag, request] as const,
}

const calculateTermPlanOptions = async ({
  queryKey: [_, creditApplicationId, _versionTag, request],
}: QueryFunctionContext<ReturnType<(typeof keysFactory)['termPlanOptions']>>) => {
  const response = await apiClient.post<TermPlanOptionsResponseDto[]>(
    `personal/CreditApplication/${encodeURIComponent(creditApplicationId)}/Worksheet/TermPlanOptions`,
    request,
  )
  return response.data
}

export function useCalculateTermPlanOptions(
  creditApp: FilteredCreditApplication | null,
  request: TermPlanOptionsRequestDto | null,
): [TermPlanOptionsResponseDto[], boolean] {
  const { isFetching, data } = useQuery({
    queryKey: keysFactory.termPlanOptions(creditApp?.id ?? '', creditApp?.versionTag ?? '', request),
    queryFn: calculateTermPlanOptions,
    enabled: creditApp !== null && request !== null,
  })

  return [data ?? EMPTY_ARRAY, isFetching]
}

